// extracted by mini-css-extract-plugin
export default {"container":"DimmingMini_container__lKe7c","value":"DimmingMini_value__oQq8t","unit":"DimmingMini_unit__YaTjX"};